import Swiper, { Navigation, FreeMode } from 'swiper';
import CalendarTable from './CalendarTable';

window.calendarTable = {};

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.jsCalendarTable')) {
    let block = document.querySelector('.jsCalendarTable');
    let infoMonth = block.querySelector('.calendar-table__month')
    let infoYear = block.querySelector('.calendar-table__year')
    let slider = new Swiper(block.querySelector('.slider__inner'), {
      modules: [Navigation, FreeMode],
      freeMode: true,
      loop: false,
      speed: 750,
      watchSlidesProgress: true,
      slidesPerView: 'auto',
      freeMode: true,
      spaceBetween: 16,
      autoHeight: true,
      navigation: {
        prevEl: block.querySelector('.swiper-button-prev'),
        nextEl: block.querySelector('.swiper-button-next'),
      },

      breakpoints: {
        1024: {
          slidesPerView: 1,
          freeMode: false,
          spaceBetween: 0,
        },
      },
      on: {
        init: function () {
          changeInfo(this.activeIndex)
        },
        update: function () {
          changeInfo(this.activeIndex)
        },
        slideChange: function () {
          changeInfo(this.activeIndex)
        }
      },
    });

    window.calendarTable.slider = slider;

    let calendar = new CalendarTable({
      element: block,
    })

    window.calendarTable.main = calendar;

    function changeInfo(index) {
      if (block.querySelector('.swiper-slide-active')) {
        let date = block.querySelectorAll('.swiper-slide')[index].getAttribute('data-calendar-date').split('; ');
        infoMonth.innerHTML != '<span>' + date[0] + '</span>' ? infoMonth.innerHTML = '<span>' + date[0] + '</span>' : '';
        infoYear.innerHTML != '<span>' + date[1] + '</span>' ? infoYear.innerHTML = '<span>' + date[1] + '</span>' : '';
      }
    }

    // window.calendarTable.main.addEvents('/assets/test.json');
  }
});
